module.exports = __webpack_public_path__ + "static/media/logo-light.0e9542e3.png";